import { render } from "./VerifyMobileNumber.vue?vue&type=template&id=206375a0"
import script from "./VerifyMobileNumber.vue?vue&type=script&lang=js"
export * from "./VerifyMobileNumber.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__